import React from 'react';
import { createComponent } from '@cloudflare/style-container';

var ClearRenderer = createComponent(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'inline-block',
    fontSize: '18px',
    fontWeight: 'normal',
    lineHeight: 1,
    ':hover': {
      color: theme.colors.red[3]
    }
  };
}, 'span');

ClearRenderer.setDisplayName('ClearRenderer');
export default function clearRenderer() {
  return React.createElement(
    ClearRenderer,
    null,
    React.createElement('span', { dangerouslySetInnerHTML: { __html: '&times;' } })
  );
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-select/es/clearRenderer.js
// module id = 641
// module chunks = 1